import React, { useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ECBadge } from 'Components/widgets/exclusive-collection-badge/ECBadge';
type Props = {
  icon?: IconName;
  isActive?: boolean;
  label: string;
  subLabel1?: string;
  subLabel2?: string;
  type?: string;
};
export const DefaultLayout = ({ icon, isActive, label, subLabel1, subLabel2, type }: Props) => {
  const [hover, setHover] = useState(false);
  const { isDesktop } = useResponsive();

  if (!label) {
    return null;
  }

  return (
    <div
      className={classnames(
        'flex cursor-pointer items-center gap-10 overflow-hidden p-10 transition-colors duration-250 ease-in hocus:bg-black hocus:text-white',
        {
          'bg-black text-white': isActive,
        },
      )}
      onMouseEnter={() => isDesktop && setHover(true)}
      onMouseLeave={() => isDesktop && setHover(false)}
    >
      {icon ? (
        <Icon
          className={classnames('shrink-0', {
            'text-black': !hover && !isActive,
          })}
          name={icon}
          width="1.25rem"
        />
      ) : (
        <ECBadge className="shrink-0" height={30} />
      )}
      <div className="decorator-match flex-1 text-16">
        {!!subLabel1 && !!subLabel2 && (
          <div
            className={classnames('text-12 leading-1', {
              'text-black': !isActive && !hover,
              'text-current': isActive || hover,
            })}
          >
            {!!subLabel1 && <span className="font-bold uppercase">{subLabel1}</span>}
            {!!subLabel1 && !!subLabel2 && <span> - </span>}
            {!!subLabel2 && <span>{subLabel2}</span>}
          </div>
        )}
        <div
          className={classnames({
            'font-brand': type === 'resort',
          })} // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      </div>
    </div>
  );
};
